import axios from "axios";
import {
  ADD_VISITOR,
  BASE_URL,
  DOWNLOAD_Authorization_QR,
  DOWNLOAD_QR,
  GET_JOINTER,
  RESEND_OTP,
  VERIFY_OTP,
  VISITOR_LOGOUT,
} from "./apiConstants";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("t")) {
    req.headers.token = JSON.parse(localStorage.getItem("t")).token;
  }
  return req;
});

//To download invoice pdf, needs to pass responseType and headers
const API_FOR_QR = axios.create({
  baseURL: BASE_URL,
  responseType: "blob",
});

API_FOR_QR.interceptors.request.use((req) => {
  if (localStorage.getItem("t")) {
    req.headers.token = JSON.parse(localStorage.getItem("t")).token;
  }
  return req;
});

// verify otp
export const verify_otp = (bodyData) =>
  API.post(`${VERIFY_OTP}`, bodyData, { withCredentials: true });

// resend otp
export const resend_otp = (bodyData) => API.post(`${RESEND_OTP}`, bodyData);

// add visitor data
export const add_visitor = (bodyData) => API.post(`${ADD_VISITOR}`, bodyData);

// get jointer details
export const get_jointer = (params = {}) =>
  API.get(GET_JOINTER, {
    params,
    responseType: "blob",
    // validateStatus: () => true,
  });

// download QR code
export const download_qr = (id) => API_FOR_QR.get(`${DOWNLOAD_QR}/${id}`);

// download Authorization letter QR code
export const download__authorization_qr = (id) => API_FOR_QR.get(`${DOWNLOAD_Authorization_QR}/${id}`);

// logout from portal
export const visitor_logout = (params) => API.delete(VISITOR_LOGOUT, { params, withCredentials: true });